import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import styles from './KioskFeedbackLayout.styles';
import { connect } from 'react-redux';
// import { Paper } from '@material-ui/core';
import EventLogHandler from '../Common/event-log-handler';
import { readSettings } from '../../helpers/board';
import {
  KioskFooter,
  KioskHeader,
  KioskFeedbackMain,
  KioskIdelScreen
} from '..';
let patientInfo = null;
export class KioskFeedbackLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  componentDidMount() {
    let sourceEnabled;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      sourceEnabled = fileData ? fileData.dynamicDataSource : false;
    } else {
      sourceEnabled = JSON.parse(localStorage.getItem('dynamicDataSource'));
    }
    patientInfo = JSON.parse(localStorage.getItem('patient'));
    if (this.props && this.props.requestPayload) {
      if (this.props.requestPayload.length > 0) {
        if (sourceEnabled === true) {
          for (let i = 0; this.props.requestPayload.length > i; i++) {
            if (this.props.requestPayload[i].name === 'saveKioskCustomer') {
              this.saveConfirmUser(this.props.requestPayload[i]);
            }
            if (this.props.requestPayload[i].name === 'updateStatusOfRx') {
              this.UpdateStatusOfRx(this.props.requestPayload[i]);
            }
            if (this.props.requestPayload[i].name === 'event') {
              this.event(this.props.requestPayload[i]);
            }
            if (this.props.requestPayload[i].name === 'sendEmail') {
              this.sendMail(this.props.requestPayload[i]);
            }
          }
        } else {
          for (let i = 0; this.props.requestPayload.length > i; i++) {
            if (this.props.requestPayload[i].name === 'sendEmail') {
              this.sendMail(this.props.requestPayload[i]);
            }
          }
        }
      }
    }
    let patient = JSON.parse(localStorage.getItem('patient'));
    patient = patient ? patient : {};
    patient[0].signature_url = '';
    patient[0].picture_url = '';
    localStorage.setItem('patient', JSON.stringify(patient));
  }
  //Save KIOSK_CONFIRM_USER
  saveConfirmUser = async payload => {
    let order_id = patientInfo[0].orders[0].id;
    let customer_id = patientInfo[0].id;
    let account_id = this.props.box.parent_account_id;
    let box_id = this.props.box.id;
    let base64Picture = null;
    let base64Signature = null;
    if (
      patientInfo[0].picture_url !== null &&
      patientInfo[0].picture_url !== '' &&
      patientInfo[0].picture_url !== undefined
    ) {
      base64Picture = patientInfo[0].picture_url.replace(
        /^data:image\/\w+;base64,/,
        ''
      );
    }
    if (
      patientInfo[0].signature_url !== null &&
      patientInfo[0].signature_url !== '' &&
      patientInfo[0].signature_url !== undefined
    ) {
      base64Signature = patientInfo[0].signature_url.replace(
        /^data:image\/\w+;base64,/,
        ''
      );
    }

    let data = new FormData();
    data.append('customer_id', customer_id);
    data.append('order_id', order_id);
    data.append('picture_url', base64Picture);
    data.append('signature_url', base64Signature);
    data.append('drivers_license_no', payload.body.formData.DriversLicenseNo);
    data.append('first_name', payload.body.formData.FirstName);
    data.append('middle_name', null);
    data.append('last_name', payload.body.formData.LastName);
    data.append('dob', payload.body.formData.dateOfBirth);
    data.append('relationship', payload.body.formData.value);
    data.append('box_id', box_id);
    data.append('account_id', account_id);
    fetch(payload.url, {
      method: payload.type,
      body: data
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData !== null && uData.length > 0) {
        }
      });
  };
  //KIOSK_DOOR_COLLECT_SEND_EMAIL
  sendMail = async payload => {
    let pickupConfig = payload.body.pickupConfig;
    let tempConfigObj = { pickupConfig };
    fetch(payload.url, {
      method: payload.type,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(tempConfigObj)
    }).then(response => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
  };
  //KIOSK_DOOR_COLLECT_UpdateStatusOfRx
  UpdateStatusOfRx = async payload => {
    fetch(payload.url, {
      method: payload.type,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload.body.updateStatusOfRxObj)
    })
      .then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(RxObj => {});
  };
  //KIOSK_DOOR_COLLECT_EVENT
  event = async payload => {
    new EventLogHandler().handleEventLog(payload.body.event_params);
  };

  //end
  handleClick = () => {
    this.props.history.push('/');
    this.props.history.push('/');
  };

  render() {
    const { classes, requestPayloads } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskFeedbackMain
          handleClick={this.handleClick}
          requestPayloads={requestPayloads}
        />
        <KioskFooter customFooterBottom={'0%'} />
        <KioskIdelScreen />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const kiosk =
    // state.get('kiosk') && state.get('kiosk').toJS && state.get('kiosk').toJS();
    state.get('kiosk');
  return {
    ...kiosk
  };
};

const KioskFeedbackContainer = connect(
  mapStateToProps,
  null
)(KioskFeedbackLayout);

export default withStyles(styles, { withTheme: true })(
  withRouter(KioskFeedbackContainer)
);
